export const MIME_COLORS: Record<string, string> = {
  "application/pdf": "red",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "green",
  "application/vnd.ms-excel": "green",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "blue",
  "application/msword": "blue",
  "image/png": "violet",
  "image/jpeg": "violet",
  "application/postscript": "violet",
  "application/vnd.ms-opentype": "cyan",
}

export const DEFAULT_MIME_COLOR = "gray"

export function getMimeColor(mimeType: string): string {
  return MIME_COLORS[mimeType] ?? DEFAULT_MIME_COLOR
}
